import "./App.css";
import "./assets/Styles/style.css";
// React Date Range Css
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import React, { Fragment, useEffect, useLayoutEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Redirect,
  Switch,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import ProtectedRouter from "./components/ProtectedRouter";
import LoginPage from "./Pages/LoginPage/LoginPage";

import Demo from "./Pages/Demo";
import SocialSignupStudentPage from "./Pages/StudentSignupPage/SocialSignupStudentPage";
import SignupStudentPage from "./Pages/StudentSignupPage/SignupStudentPage";
import SocialSignupCoachPage from "./Pages/CoachSignupPage/SocialSignupCoachPage";
import SignupCoachPage from "./Pages/CoachSignupPage/SignupCoachPage";
import WelcomePage from "./Pages/WelcomePage/WelcomePage";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage/ForgotPasswordPage";
import ResetPasswordPage from "./Pages/ResetPassword/ResetPasswordPage";
import OnBoardingScreen from "./Pages/CoachFlow/OnBoarding/OnBoardingScreen/OnBoardingScreen";
import CoachDetailsPreviewProfile from "./Pages/CoachFlow/OnBoarding/CoachDetailsPreviewProfile/CoachDetailsPreviewProfile";
import CoachingStartProfileSetup from "./Pages/CoachFlow/OnBoarding/CoachingStartProfileSetup/CoachingStartProfileSetup";
import CheckYourEmail from "./Pages/CheckYourEmail/CheckYourEmail";
import AllSteps from "./Pages/CoachFlow/OnBoarding/AllSteps/AllSteps";
import DashboardScreen from "./Pages/CoachFlow/Dashboard/DashboardScreen/DashboardScreen";
import Filters from "./components/CoachFlow/CoachDashboard/Filters/Filters";
import Partnership from "./Pages/GeneralScreens/Partnership/Partnership";
import BecomeAnInvestor from "./Pages/GeneralScreens/BecomeAnInvestor/BecomeAnInvestor";
import Help from "./Pages/GeneralScreens/Help/Help";
import EvaluatePerformance from "./components/CoachFlow/CoachDashboard/EvaluatePerformance/EvaluatePerformance";
import ContactUs from "./Pages/GeneralScreens/ContactUs/ContactUs";
import PageNotFound from "./Pages/GeneralScreens/PageNotFound/PageNotFound";
import ServerSideMaintenance from "./Pages/GeneralScreens/ServiceSideMaintenance/ServiceSideMaintenance";
import DashboardMobileScreen from "./Pages/CoachFlow/Dashboard/DashboardScreen/DashboardMobileScreen";
import PersonalInfo from "./Pages/CoachFlow/Settings/EditProfile/PersonalInfo/PersnalInfo";
import PhotosAndVideos from "./Pages/CoachFlow/Settings/EditProfile/PhotosAndVideos/Photos&Videos";
import Faq from "./Pages/CoachFlow/Settings/EditProfile/Faq/Faq";
import BasicInfo from "./Pages/CoachFlow/Settings/EditLesson/BasicInfo/BasicInfo";
import Location from "./Pages/CoachFlow/Settings/EditLesson/Location/Location";

// import TodoWithoutFinishingOnMobile from "./components/CoachFlow/CoachDashboard/TodoWithoutFinishingOnBoarding/TodoWithoutFinishingOnMobile";
import WhatsIncluded from "./Pages/CoachFlow/Settings/EditLesson/WhatsIncluded/WhatIncluded";
import PrivacySettings from "./Pages/CoachFlow/Settings/ProfileSettings/PrivacySettings/PrivacySettings";
import TodoWithoutFinishingOnMobile from "./components/CoachFlow/CoachDashboard/TodoWithoutFinishingOnBoarding/TodoWithoutFinishingOnMobile";
import Home from "./Pages/HomePage/HomePage";
import PayoutMethod from "./Pages/CoachFlow/Settings/ProfileSettings/PayoutMethods/PayoutMethods";
import Notification from "./Pages/CoachFlow/Settings/ProfileSettings/Notifications/Notifications";
import Reviews from "./Pages/CoachFlow/Reviews/Review";
import NotificationDetail from "./Pages/CoachFlow/Notifications/Notifications";
import CoachMessages from "./Pages/CoachFlow/Messages/Messages";
import Insights from "./Pages/CoachFlow/Insights/Insights";
import EditProfile from "./Pages/CoachFlow/Settings/EditProfile";
import EditLesson from "./Pages/CoachFlow/Settings/EditLesson";
import ProfileSettings from "./Pages/CoachFlow/Settings/ProfileSettings";
import ProfileMobile from "./components/CoachFlow/CoachDashboard/Profile/ProfileMobile";
import Schedule from "./Pages/CoachFlow/Schedule/Schedule";
import HomePage from "./Pages/StudentFlow/HomePage/HomePage";
import HomePageV1 from "./Pages/StudentFlow/HomePageV1/HomePageV1";
import VerifedEmailPage from "./Pages/VerifedEmailPage/VerifedEmailPage";
import Search from "./Pages/StudentFlow/Search/Search";
import CoachDetail from "./Pages/StudentFlow/CoachDetail/CoachDetail";
import User from "./Pages/Admin/UserManagement/User/User";
import ConfirmBookingSignup from "./Pages/StudentFlow/ConfirmBooking/SignUp/SignUp";
import SearchResults from "./Pages/StudentFlow/SearchResults/SearchResults";
import ConfirmBookingLessonPage from "./Pages/StudentFlow/ConfirmBooking/BookingLesson/ConfirmBookingLessonPage";
import StudentFlowFavoritesDesktop from "./Pages/StudentFlow/Favorites/FavoritesDesktop";
import UserManagement from "./Pages/Admin/UserManagement/User/User";

import Steps from "./Pages/StudentFlow/GetAMatch/Steps/Steps";
import Notifications from "./Pages/StudentFlow/Notifications/Notifications";
import StudentDashboard from "./Pages/StudentFlow/Dashboard/Dashboard";
import Messages from "./Pages/StudentFlow/Messages/Messages";
import UserFeedback from "./Pages/Admin/UserFeedback/UserFeedback";
import UserComplaints from "./Pages/Admin/UserComplaints/UserComplaints";
import Settings from "./Pages/StudentFlow/Settings/Settings";
import AccountSettings from "./Pages/Admin/AccountSettings/AccountSettings";
import Requests from "./Pages/Admin/Requests/Requests";
import AdminMessages from "./Pages/Admin/Messages/Messages";
import UpcomingLesson from "./Pages/StudentFlow/Dashboard/UpcomingLesson/UpcomingLesson";
import GetAMatch from "./Pages/StudentFlow/GetAMatch/Steps/Steps";
import AdminDashboard from "./Pages/Admin/AdminDashboard/AdminDashboard";
import PerformanceEvaluationDesktop from "./Pages/StudentFlow/Dashboard/PerformanceEvaluation/PerformanceEvaluation";
import AdminCoachDetails from "./Pages/Admin/Requests/CoachDetail/CoachDetail";
import StudentCoachDetails from "./Pages/StudentFlow/CoachDetail/CoachDetail";
import BookingLesson from "./Pages/StudentFlow/ConfirmBooking/BookingLesson/MobileBookingLessonPage";
function App() {
  const { isLogin, role } = useSelector((state) => state.authReducer);
  return (
    <>
      <ToastContainer />
      <Router>
        <Switch>
          {/* Auth Screen Start */}
          <Route exact path="/">
            <Redirect
              to={
                isLogin && role == "student"
                  ? "/homepage"
                  : isLogin && role == "coach-pending"
                    ? "/todo"
                    : "/welcome"
              }
            />
          </Route>
          {/* {isLogin == false && ( */}
          {/* <> */}
          <Route path="/login" exact component={LoginPage} />
          <Route path="/welcome" exact component={WelcomePage} />
          <Route
            path="/socialSignupStudent"
            exact
            component={SocialSignupStudentPage}
          />
          <Route path="/signupStudent" exact component={SignupStudentPage} />
          <Route
            path="/socialSignupCoach"
            exact
            component={SocialSignupCoachPage}
          />
          <Route path="/signupCoach" exact component={SignupCoachPage} />
          <Route path="/forgotPassword" exact component={ForgotPasswordPage} />
          <Route path="/resetPassword" exact component={ResetPasswordPage} />
          <Route path="/check-your-email" exact component={CheckYourEmail} />
          <Route path="/verify-email" exact component={VerifedEmailPage} />
          {/* </> */}
          {/* // )} */}
          {/* Auth Screen End */}
          {/* General Screen Start */}
          <Route path="/partnership" exact component={Partnership} />
          <Route path="/become-an-investor" component={BecomeAnInvestor} />
          <Route path="/contact-us" exact component={ContactUs} />
          <Route path="/help" exact component={Help} />
          <Route path="/500" exact component={ServerSideMaintenance} />
          <Route path="/404" component={PageNotFound} />
          {/* General Screen End */}
          {/* CoachFLow Screens Start */}
          {/* OnBoardingScreen Section */}
          <Route
            path="/coach-setup-profile"
            exact
            component={CoachingStartProfileSetup}
          />
          <Route path="/on-boarding" exact component={OnBoardingScreen} />
          <Route
            path="/profile-preview"
            exact
            component={CoachDetailsPreviewProfile}
          />
          {/* OnBoardingScreen Section */}
          {/* DashboardScreen Section */}
          <Route path="/all-steps" exact component={AllSteps} />
          <Route path="/todo" exact component={DashboardScreen} />
          {/* DashboardScreen Section */}
          {/* Schedule Section */}
          <Route path="/schedule" component={Schedule} />
          {/* Schedule Section */}
          {/* chat Section */}
          <Route path="/chat" exact component={CoachMessages} />
          {/* chat Section */}
          {/* Setting Section */}
          <Route path="/profile" component={ProfileMobile} />
          <Route path="/edit-profile" exact component={EditProfile} />
          <Route path="/edit-lesson-info" exact component={EditLesson} />
          <Route path="/profile-settings" exact component={ProfileSettings} />
          {/* Setting Section */}
          {/* Review Section */}
          <Route path="/reviews" exact component={Reviews} />
          {/* Review Section */}
          {/* Notification Section */}
          <Route path="/notifications" exact component={NotificationDetail} />
          {/* Notification Section */}
          {/* insights Section */}
          <Route path="/insights" exact component={Insights} />
          {/* insights Section */}
          {/* CoachFLow Screens End */}
          {/* Student Flow Start */}
          {/* Home Page Start */}
          <ProtectedRouter path="/homepage" exact component={HomePageV1} />
          {/* Home Page End */}
          {/* Search Results Start */}
          <Route path="/search-results" exact component={SearchResults} />
          {/* Search Results End */}
          {/* Notifications Start */}
          <Route
            path="/student-notifications"
            exact
            component={Notifications}
          />
          {/* Notifications End */}
          {/* Confirm Booking Start */}
          <Route
            path="/student-booking"
            exact
            component={ConfirmBookingLessonPage}
          />
          <Route
            path="/student-signup"
            exact
            component={ConfirmBookingSignup}
          />
          {/* Confirm Booking End */}
          {/* Coach Detail Start */}
          <Route path="/coach-detail" exact component={StudentCoachDetails} />
          {/* Settings Start */}

          <Route path="/student-settings" exact component={Settings} />
          {/* Settings End */}

          {/* Chat Start */}

          <Route path="/student-chat" exact component={Messages} />
          {/* Chat End */}

          {/* Coach Detail End */}

          {/* Student Dashboard Start*/}
          <Route path="/student-dashboard" exact component={StudentDashboard} />
          <Route path="/lesson-details" exact component={UpcomingLesson} />
          <Route
            path="/performance-evaluation"
            exact
            component={PerformanceEvaluationDesktop}
          />

          {/* Student Dashboard End*/}

          {/* Get A Match Start*/}
          <Route path="/get-a-match" exact component={GetAMatch} />
          {/* Get A Match End*/}

          {/* Student Flow End */}
          <Route path="/demo" exact component={Demo} />
          <Route
            path="/confirm-booking"
            exact
            component={ConfirmBookingLessonPage}
          />
          <Route
            path="/confirm-boooking-signup"
            exact
            component={ConfirmBookingSignup}
          />
          <Route
            path="/student-flow-favorites"
            exact
            component={StudentFlowFavoritesDesktop}
          />
          <Route path="/admin/dashboard" exact component={AdminDashboard} />
          <Route path="/admin/users" exact component={UserManagement} />
          <Route path="/admin/reviews" exact component={UserFeedback} />
          <Route path="/admin/complaints" exact component={UserComplaints} />
          <Route path="/admin/settings" exact component={AccountSettings} />
          <Route path="/admin/requests" exact component={Requests} />
          <Route path="/admin/messages" exact component={AdminMessages} />
          <Route
            path="/admin/coach-profile-preview"
            exact
            component={AdminCoachDetails}
          />

          {/* Demo */}
          {/* Dummy Route End */}
          <Route path="*" component={PageNotFound} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
